import type { Template } from "@/types";

export const PO_02_H1_V1: Template[] = [
{
    id: "po-02-h1v1-01",
    name: "PO 01 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_01.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 53, y: 254, width: 462, height: 348, rotation: 0, imageRotation: 0 },
            { id: "2", x: 711, y: 188, width: 283, height: 478, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-02",
    name: "PO 02 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_02.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 53, y: 254, width: 462, height: 348, rotation: 0, imageRotation: 0 },
            { id: "2", x: 666, y: 113, width: 371, height: 628, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-03",
    name: "PO 03 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_03.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 53, y: 254, width: 462, height: 348, rotation: 0, imageRotation: 0 },
            { id: "2", x: 568, y: 0, width: 568, height: 854, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-04",
    name: "PO 04 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_04.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 0, y: 214, width: 568, height: 426, rotation: 0, imageRotation: 0 },
            { id: "2", x: 601, y: 0, width: 503, height: 854, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-05",
    name: "PO 05 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_05.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 48, y: 136, width: 705, height: 576, rotation: 0, imageRotation: 0 },
            { id: "2", x: 760, y: 136, width: 328, height: 576, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-06",
    name: "PO 06 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_06.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 0, y: 118, width: 777, height: 617, rotation: 0, imageRotation: 0 },
            { id: "2", x: 784, y: 119, width: 351, height: 616, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-07",
    name: "PO 07 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_07.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 98, y: 113, width: 371, height: 628, rotation: 0, imageRotation: 0 },
            { id: "2", x: 621, y: 254, width: 462, height: 348, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-08",
    name: "PO 08 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_08.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 568, height: 854, rotation: 0, imageRotation: 0 },
            { id: "2", x: 621, y: 254, width: 462, height: 348, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-09",
    name: "PO 09 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_09.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 32, y: 0, width: 503, height: 854, rotation: 0, imageRotation: 0 },
            { id: "2", x: 568, y: 214, width: 568, height: 426, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-10",
    name: "PO 10- H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_10.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 142, y: 188, width: 283, height: 478, rotation: 0, imageRotation: 0 },
            { id: "2", x: 621, y: 254, width: 462, height: 348, rotation: 0, imageRotation: 0 }
    ],
}
];